//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'RingSizeSelector',
  props: {
    control: {required: true},
    data: {required: true},
    product: {required: true},
    stonePositions: {required: false},
  },
  data() {
    return {
      
    }
  },
  computed: {
    ringSizes() {
      const metalColor = this.data.MA[Object.keys(this.data.MA)[0]].Value
      const metalGroupOptions = this.control.GroupedOptions.find(
        (x) => x.Key == metalColor
      )
      if (metalGroupOptions) {
        return metalGroupOptions.Options/*.filter(
            (opt) =>
                parseFloat(opt.text) % 1 !== 0.25 &&
                parseFloat(opt.text) % 1 !== 0.75
        )*/ // temporary enabled 0.25 and 0.75 ring sizes
      } else {
        return []
      }
    },
    selectedSizeCharge() {
      const ringSize =
        this.data[this.control.name] &&
        this.data[this.control.name].Value &&
        this.ringSizes.find(
          (x) => x.value == this.data[this.control.name].Value
        )
      return ringSize && ringSize.text2
    },
  },
  methods: {
    ringSizeChanged(v) {
      this.$emit('updateValue', {
        controlType: this.control.type,
        controlName: this.control.name,
        value: v,
      })
    },
  },
}
